export default class UserEditController {
    constructor($routeParams, $window, $mdDialog, userService) {
        this.$window = $window;
        this.userService = userService;
        this.$routeParams = $routeParams;
        this.$mdDialog = $mdDialog;
        if($routeParams.clientId != null)
            this.clientId = $routeParams.clientId;

        this.userService.get($routeParams.id).then(resp => {
            this.user = resp.data;
            this.user.Id = $routeParams.id;
            this.user.endDate = resp.data.subscription.endDate;
            this.user.startDate = resp.data.subscription.startDate;
        }, error => {
            $location.path("/");
        });
    }
 
    onSave() { 
        this.userService.update(this.user).then(resp => {
            this.$window.history.back();
        }, resp =>{
            console.log("ERROR UPDATING USER")
        });
    }

    goBack(){
        this.$window.history.back();
    }

    delete(){
        this.userService.delete(this.$routeParams.id).then(resp => {
            this.$window.location.href = "#!/manage/";
        });
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteUserDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteUserDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}


// WEBPACK FOOTER //
// ./src/js/components/users/users.edit.controller.js